import { ThunkDispatch } from "core-integration/src/store";
import { fetchEventLive } from "core-integration/src/store/elements/thunks";
import {
  getCurrentEvent,
  getNextEvent,
} from "core-integration/src/store/events/reducers";
import { fetchFixtures } from "core-integration/src/store/fixtures/thunks";
import { fetchMyTeam } from "core-integration/src/store/my-team/thunks";
import { getTransferState } from "core-integration/src/store/squad/reducers";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { HelmetHead } from "../HelmetHead";
import { LeaderboardAd } from "../LeaderboardAd";
import SquadBase from "./SquadBase";
import { TransfersScoreboard } from "./TransfersScoreboard";

const Transfers = () => {
  const { t } = useTranslation("transfers");

  const dispatch = useDispatch<ThunkDispatch>();
  const currentEvent = useSelector(getCurrentEvent);
  const nextEvent = useSelector(getNextEvent);
  const transfersState = useSelector(getTransferState);

  useEffect(() => {
    dispatch(fetchMyTeam());
    if (currentEvent) {
      dispatch(fetchFixtures(currentEvent.id));
      dispatch(fetchEventLive(currentEvent.id));
    }
  }, [dispatch, currentEvent]);

  // Don't render until we know what transfers state we need to render ...
  if (!transfersState) {
    return null;
  }

  return (
    <>
      <LeaderboardAd slot="Leaderboard_Transfers" id="ism-transfers-ad" />
      <SquadBase
        scoreboard={<TransfersScoreboard />}
        title={t("transfers", "Transfers")}
        headTags={
          <HelmetHead
            title={t(
              "metadata.title",
              "Fantasy Football Transfers | Fantasy Premier League",
            )}
            description={t(
              "metadata.description",
              "To make transfers in your Fantasy Premier League team and consider playing your wildcard, visit the official website of the Premier League.",
            )}
          />
        }
        nextEvent={nextEvent}
      />
    </>
  );
};

export default Transfers;
